/* eslint-disable no-console -- because that's what this file ultimately does */
import { LogEntry } from './types';
import { err as errorSerializer } from 'pino-std-serializers';

enum LogLevel {
  // TRACE is the same as DEBUG for the purposes of this logger
  DEBUG = 20,
  INFO = 30,
  WARN = 40,
  ERROR = 50,
}

function currentLogLevel(): LogLevel {
  const logLevelString = (process.env['LOG_LEVEL'] ?? '').toUpperCase();
  switch (logLevelString) {
    case 'DEBUG':
    case 'INFO':
    case 'WARN':
    case 'ERROR':
      return LogLevel[logLevelString];
    default:
      return LogLevel.DEBUG;
  }
}

/**
 * All log entries should have the following structure:
 * {
 *  level: string,
 *  time: number,
 *  msg: string,
 *  data?: unknown,
 *  err?: unknown
 *  }
 *
 * @param level
 * @param message
 * @param data
 * @param error
 */
function buildLogEntry(
  level: string,
  message: string,
  data: unknown,
  error?: unknown,
) {
  const logEntry: LogEntry = { level, time: Date.now(), msg: message };
  if (data) {
    logEntry.data = data;
  }

  if (error instanceof Error) {
    logEntry.err = errorSerializer(error);
  } else if (error) {
    logEntry.err = JSON.stringify(error);
  }

  // return logEntry;
  return JSON.stringify(logEntry);
}

export const serverLogger = {
  debug: (message: string, data?: unknown) => {
    if (currentLogLevel() > LogLevel.DEBUG) {
      return;
    }

    console.debug(buildLogEntry('debug', message, data));
  },
  info: (message: string, data?: unknown) => {
    if (currentLogLevel() > LogLevel.INFO) {
      return;
    }

    console.info(buildLogEntry('info', message, data));
  },
  warn: (message: string, data?: unknown) => {
    if (currentLogLevel() > LogLevel.WARN) {
      return;
    }

    console.warn(buildLogEntry('warn', message, data));
  },
  error: (message: string, error: unknown, data?: unknown) => {
    if (currentLogLevel() > LogLevel.ERROR) {
      return;
    }

    console.error(buildLogEntry('error', message, data, error));
  },
};
